import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-curd-material-master',
  templateUrl: './curd-material-master.component.html',
  styleUrls: ['./curd-material-master.component.css']
})
export class CurdMaterialMasterComponent {
  mode: 'add' | 'edit' | 'view' = 'view';
   materialForm: FormGroup;
 resourceId: string | null = null;
  constructor(private route: ActivatedRoute, private fb: FormBuilder) {
    this.materialForm = this.fb.group({
  company: ['', Validators.required],
  contactName: ['', Validators.required],
  phone: ['', Validators.required],
  email: ['', [Validators.required, Validators.email]],
  materialType: ['', Validators.required],
  materialName: ['', Validators.required],
  supplierPartNumber: [''],
  clientPartNumber: [''],
  machineReference: [''],
  uom: [''],
  storeKeeper: [''],
  safetyCertNo: [''],
  licenseNo: [''],
  storageLocation: [''],
  qty: [0, Validators.min(0)],
  consumptionPerMeter: [''],
  expiryDate: [''],
  storageInstructions: [''],
  minOrderLevel: [''],
  minReorderQty: [''],
  leadTime: [''],
  dailyConsumptionPattern: [''],
  costPerUnit: [0, Validators.min(0)],
});
  }

  ngOnInit() {
    // Get mode from route data
    this.mode = this.route.snapshot.data['mode'] || 'add';

    // Get ID for edit/view
    this.resourceId = this.route.snapshot.paramMap.get('id');

    this.buildForm();

    if (this.mode === 'edit' || this.mode === 'view') {
      // Fetch resource by ID (mock here)
      const mockData = {
  company: 'Acme Infra Ltd.',
  contactName: 'John Doe',
  phone: '+91-9876543210',
  email: 'john.doe@acmeinfrastructure.com',
  materialType: 'Consumable',
  materialName: 'Diesel',
  supplierPartNumber: 'SUP-DS-001',
  clientPartNumber: 'CLI-DS-078',
  machineReference: 'Excavator - CAT 320D',
  uom: 'Litre',
  storeKeeper: 'Ravi Sharma',
  safetyCertNo: 'CERT-4578',
  licenseNo: 'LIC-EXP-2457',
  storageLocation: 'Site Warehouse A',
  qty: 500,
  consumptionPerMeter: '0.2 L/m',
  expiryDate: new Date('2025-12-31'),
  storageInstructions: 'Keep in sealed drum. Away from sunlight.',
  minOrderLevel: 100,
  minReorderQty: 200,
  leadTime: '3 days',
  dailyConsumptionPattern: '50 Litres per day',
  costPerUnit: 95.75
};
     
      this.materialForm.patchValue(mockData);
    }

    if (this.mode === 'view') {
      this.materialForm.disable();
    }
  }

    buildForm() {
      this.materialForm = this.fb.group({
  company: ['', Validators.required],
  contactName: ['', Validators.required],
  phone: ['', Validators.required],
  email: ['', [Validators.required, Validators.email]],
  materialType: ['', Validators.required],
  materialName: ['', Validators.required],
  supplierPartNumber: [''],
  clientPartNumber: [''],
  machineReference: [''],
  uom: [''],
  storeKeeper: [''],
  safetyCertNo: [''],
  licenseNo: [''],
  storageLocation: [''],
  qty: [0, Validators.min(0)],
  consumptionPerMeter: [''],
  expiryDate: [''],
  storageInstructions: [''],
  minOrderLevel: [''],
  minReorderQty: [''],
  leadTime: [''],
  dailyConsumptionPattern: [''],
  costPerUnit: [0, Validators.min(0)],
});
    }

  setMode(newMode: 'add' | 'edit' | 'view') {
  this.mode = newMode;
  if (newMode === 'view') {
    this.materialForm.disable();
  } else {
    this.materialForm.enable();
  }
}

  onSubmit() {
    if (this.materialForm.valid) {
      console.log(`${this.mode === 'edit' ? 'Updating' : 'Adding'} resource:`, this.materialForm.value);
      // Handle API call
    } else {
      this.materialForm.markAllAsTouched();
    }
  }

}
